import Vue from 'vue';
import Antd from 'ant-design-vue';
import {
    message
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less'
import App from './App.vue'
import router from './router'
import store from './store'
import 'url-search-params-polyfill'
import "babel-polyfill";
import Print from 'vue-print-nb';
import i18n from './locales/i18n'
import { routerIsParamsOrQuery } from "./utils/router";
import { initSensors } from './utils/sensors'
Vue.use(Print);

Vue.config.productionTip = false

//全局守卫,防止未登录用户跳转到其他页面
router.beforeEach((to, form, next) => {
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if (to.path == '/login' || to.path == '/') {
        next();
    } else if (userInfo && userInfo.Authorization != '') {
        // console.log('localStorage.getItem(Authorization)) ==== ', userInfo.Authorization);
        const { originalPath } = routerIsParamsOrQuery(to);
        const pageTabs = store.getters.getPageTabs;
        const isExist = pageTabs.some(item => item.path === originalPath);
        store.commit("setCurrentTabKey", originalPath);
        if (!isExist) {
            store.commit("setPageTabs", [...pageTabs, { path: originalPath, title: to.meta.title }]);
        }
        next();
    } else {
        // alert("还没有登录，请先登录！");
        message.error("还没有登录，请先登录！");
        next('/login');
    }
})


Vue.use(Antd);

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
initSensors()

window.snapshot = []